import { Controller } from 'stimulus'

import 'select2/dist/js/select2'

export default class extends Controller {
    static targets = ['picker']

    connect() {
        const picker = $(this.pickerTarget).select2({ theme: 'bootstrap4' })

        picker.on('select2:select select2:unselect', (event) => {
            // Dispatch JS change event to listen from stimulus controllers on change event.
            const changeEvent = new Event('change', { bubbles: true })
            event.currentTarget.dispatchEvent(changeEvent)
        })
    }
}
